import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }

import { computed } from 'vue';
import AddToBasketHandler from '@/b2c/shared/checkout/ui/AddToBasketHandler.vue';
import dictionaryService from '@/core/dictionary/dictionary.service';
import useTEMPB2CFeatureBasket from '@/b2c/basket/useTEMPB2CFeatureBasket';
import { PurchaseOptionType, PurchaseOption } from '@/types/productServerApi';
import siteContextService from '@/b2c/shared/site-context.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddToBasket',
  props: {
    items: null,
    quantity: { default: 1 },
    buttonText: { default: dictionaryService.get('b2c/basket/add') },
    allowAddToBasket: { type: Boolean, default: true },
    lightMode: { type: Boolean }
  },
  emits: ['addToBasket'],
  setup(__props: any, { emit }) {

const props = __props as { items: { sku: string, purchaseOptions: PurchaseOption[], variantId: string }[], quantity: number, buttonText: string, allowAddToBasket: boolean, lightMode?: boolean }

const { addRegular, addPickAndPack } = useTEMPB2CFeatureBasket();


const areItemsAddToBasketScenariosCovered = computed(() => {
    return props.items.every(item => item.purchaseOptions.filter(
        purchaseOption => {
            return purchaseOption.type === PurchaseOptionType.Standard || purchaseOption.type === PurchaseOptionType.PickAndPack;
        }).length,
    );
});

const canAddToBasket = computed(() => {
    return props.allowAddToBasket && !siteContextService.isBrandSite;
});



const addToBasket = async() => {
    if (!areItemsAddToBasketScenariosCovered.value) {
        return;
    }
    emit('addToBasket');
    props.items.forEach(item => {
        if (item.purchaseOptions.find(option => option.type === PurchaseOptionType.Standard)) {
            addRegular(item.sku, props.quantity);
        } else if (item.purchaseOptions.find(option => option.type === PurchaseOptionType.PickAndPack)) {
            addPickAndPack(item.sku, props.quantity);
        }
    });
};

return (_ctx: any,_cache: any) => {
  return (_unref(canAddToBasket) && _unref(areItemsAddToBasketScenariosCovered))
    ? (_openBlock(), _createBlock(AddToBasketHandler, _mergeProps({ key: 0 }, props, { handler: addToBasket }), null, 16))
    : (_unref(canAddToBasket) && !_unref(areItemsAddToBasketScenariosCovered))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "not-buyable-from-current-location")
        ]))
      : _createCommentVNode("", true)
}
}

})